var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.currentComponent)?_c(_vm.currentComponent,{tag:"component",attrs:{"data":_vm.data,"config":_vm.config},on:{"update:data":[function($event){_vm.data=$event},_vm.onDataUpdated]}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }